"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Filtr_1 = require("../../../../components/Filtr/Filtr");
var BaseBlock = function (_a) {
    var value = _a.value, label = _a.label;
    return (react_1.default.createElement("div", null,
        label,
        react_1.default.createElement("br", null),
        react_1.default.createElement(Filtr_1.Filtr, null, value)));
};
exports.default = BaseBlock;
